import { normalizeFields } from "@/forms/helpers";
import {
  createUserBirthdayDateModel,
  createUserLicenceModel,
  createUserNameModel,
  createUserNewsletterModel,
  createUserTypeModel,
  createUserVerificationImageModel,
} from "@/forms/form-types/user-model";
import {
  isDiplomaType,
  isDoctorOrDentistType,
  pwzUserType,
} from "@/service/user-groups";

export function createFormFields(
  type: string | null,
  dataForType: DataForType,
  defaultNewsletter: UserNewsletterVM,
  isNewsletterRequired: boolean,
) {
  return normalizeFields({
    ...createUserTypeModel(null),
    ...(isDiplomaType(type as string)
      ? {
          ...createUserNameModel(dataForType),
          ...createUserVerificationImageModel(),
        }
      : {}),
    ...(isDoctorOrDentistType(type as string)
      ? {
          ...createUserBirthdayDateModel(""),
          ...createUserLicenceModel(),
        }
      : {}),
    ...(pwzUserType(type) && !isDoctorOrDentistType(type)
      ? createUserLicenceModel(dataForType)
      : {}),
    ...(!isDiplomaType(type as string) &&
    !isDoctorOrDentistType(type as string) &&
    type &&
    !defaultNewsletter.isSignedUp
      ? createUserNewsletterModel(isNewsletterRequired)
      : {}),
  });
}
